/* eslint-disable no-unused-vars */
import { Box } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { Control, useController } from 'react-hook-form'
interface IHRMEDateFieldProps {
  name: string
  control: Control<any>
  label: string
  inputProps?: any
}

export function CustomDateField({ name, control, label, ...inputProps }: IHRMEDateFieldProps) {
  const [cleared, setCleared] = useState<boolean>(false)
  const {
    field: { value = null, onChange, ref }
  } = useController({
    name,
    control
  })

  useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false)
      }, 1500)

      return () => clearTimeout(timeout)
    }
    return () => {}
  }, [cleared])

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          value={value ? dayjs(value) : null}
          format="DD/MM/YYYY"
          // defaultValue={dayjs('2022-04-17')}
          onChange={onChange}
          inputRef={ref}
          slotProps={{
            field: { clearable: true, onClear: () => setCleared(true) },
            textField: {
              fullWidth: true,
              size: 'small',
              margin: 'normal'
            },
            actionBar: { actions: ['today', 'clear', 'cancel', 'accept'] }
          }}
        />
      </LocalizationProvider>
    </Box>
  )
}
